/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserComplianceResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }],
} as const;
